import { formatMoney, formatNumber, formatPercent, formatUsDate, formatUsDateTime } from '@/filters';

const reportComponents = new Set([
  'AccountsPayable',
  'BalanceIssues',
  'ReportAgentSourceSales',
  'ReportCancellation',
  'ReportCdPosterPerformance',
  'ReportDealerSales',
  'ReportDispatchSales',
  'ReportFollowups',
  'ReportLeads',
  'ReportOrders',
  'ReportPayments',
  'ReportQuotes',
  'ReportSales',
  'ReportSourceSales',
]);

const moneyField = /(amount|price|cost|tar+if+s?|carrierPay|deposit|gross|profit|fee|surcharge|owes|revenue|receivedPay|paid|credit|balance|due)/i;
const numberField = /(count|total)$|^p[0-4]$|^(totalPosted|dispatchedBeforePuw|dispatchedDuringPuw|stillPostedAfterPuw|visibilitiesPosted|followupsExpired|followupsFuture)$/i;
const dateTimeField = /At$/i;
const dateField = /(Date|DateLast)$/i;
const percentField = /(rate|margin|ratio|percentage|percent)$/i;

function formatReportField(field) {
  if (!field || !field.key || /Id$/i.test(field.key) || field.key === 'deletedAt' || field.formatter && !moneyField.test(field.key)) return field;

  const formatter = percentField.test(field.key)
    ? formatPercent
    : dateTimeField.test(field.key)
    ? formatUsDateTime
    : dateField.test(field.key)
      ? formatUsDate
      : moneyField.test(field.key)
    ? formatMoney
    : numberField.test(field.key)
      ? formatNumber
      : null;

  if (!formatter) return field;

  const originalFormatter = field.formatter;
  const formattedField = {
    ...field,
    formatter: originalFormatter
      ? (value, key, item) => formatter(originalFormatter(value, key, item))
      : value => formatter(value),
  };

  if (originalFormatter && field.sortByFormatted === true) {
    formattedField.sortByFormatted = originalFormatter;
  }

  return formattedField;
}

function formatReportValue(key, value) {
  if (value === null || value === undefined || value === '') return '';
  if (/Id$/i.test(key)) return value;
  if (percentField.test(key)) return formatPercent(value, '');
  if (moneyField.test(key)) return formatMoney(value, '');
  if (numberField.test(key)) return formatNumber(value, '');
  return value;
}

export const tabActive = {
  methods: {
    getTabActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },
  },
};

export const tableFields = {
  created() {
    if (!reportComponents.has(this.$options.name)) return;

    Object.keys(this.$data)
      .filter(key => /fields$/i.test(key) && Array.isArray(this.$data[key]))
      .forEach(key => {
        this.$data[key] = this.$data[key].map(formatReportField);
      });
  },
  methods: {
    formatReportValue,
    getTableFields(fields) {
      return fields.map(item => {
        const isActions = item.key === 'actions';
        return {
          sortable: isActions ? false : true,
          tdClass: isActions ? 'text-nowrap align-middle text-center' : 'align-middle',
          label: isActions ? '' : undefined,
          ...item,
        };
      });
    },
  },
};

export const confirmModal = {
  methods: {
    handleOpenConfirmModal(
      desc = 'Are you sure ?',
      title = 'Confirm',
      okVariant = 'primary',
      okTitle = 'YES',
      cancelTitle = 'NO',
      size = 'md',
      buttonSize = 'md',
      headerClass = '',
      footerClass = '',
      hideHeaderClose = true,
      centered = true
    ) {
      return new Promise((resolve, reject) => {
        this.$bvModal
          .msgBoxConfirm(desc, {
            title,
            size,
            buttonSize,
            okVariant,
            okTitle,
            cancelTitle,
            headerClass,
            footerClass,
            hideHeaderClose,
            centered,
          })
          .then(value => {
            resolve(value);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
};
